import { jsPDF } from "jspdf";
import { fechaActual, subespecimen } from "../store/action";
import logoMuseo from '../componentes/img/logomuseogrande.png';

export const printHojaRuta = (especimen, formData, que) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 14;
    let y = 14;
    // Helper to format YYYY-MM-DD to DD/MM/YYYY
    const formatDate = (dateStr) => {
        if (!dateStr || !dateStr.includes('-')) return dateStr || "___________________________";
        const [year, month, day] = dateStr.split('-');
        return `${day}/${month}/${year}`;
    };

    // Helper to draw a line with text
    const drawLineWithText = (label, value, x, y, noUnderscoreFields = []) => {
        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text(label + ":", x, y);
        const labelWidth = doc.getTextWidth(label + ": ");

        doc.setFont("helvetica", "normal");
        const isExcluded = noUnderscoreFields.includes(label);
        const displayValue = value && value !== "Sin datos" ? value : (isExcluded ? "" : "___________________________");
        doc.text(String(displayValue), x + labelWidth, y);
    };

    // Header
    doc.addImage(logoMuseo, margin, 8, 46, 20);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.setTextColor(35, 62, 50);
    doc.text("INSTITUTO Y MUSEO DE CIENCIAS NATURALES", margin + 50, 14);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.setTextColor(60, 60, 60);
    doc.text("CATÁLOGO DE PALEOVERTEBRADOS", margin + 50, 19);
    doc.setDrawColor(200, 210, 204);
    doc.line(margin, 25, pageWidth - margin, 25);
    y = 30;
    // Row 1
    drawLineWithText("Fecha de recepción", formatDate(formData.fechaRecepcion), 10, 50);
    drawLineWithText("Nombre del Investigador responsable", formData.investigador, 85, 50);

    // Row 2
    const nroStr = que === 'especimen' ? 'PVSJ ' + subespecimen(especimen.especimennumero) : 'PVBSJ ' + especimen.bochonnumero;
    drawLineWithText("Número de inventario del material", nroStr, 10, 60);
    drawLineWithText("Lugar asignado en laboratorio/ depósito", formData.lugarLaboratorio, 110, 60);

    // Info Section
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.setFillColor(240, 240, 240);
    doc.rect(10, 68, pageWidth - 20, 7, 'F');
    doc.text("Información del fósil", pageWidth / 2, 73, { align: "center" });

    // Row 3
    const noUnderscores = ["Cantidad de bolsas", "Cantidad de bochones", "Formación Geológica", "Observaciones"];
    drawLineWithText("Cantidad de bolsas", formData.cantidadBolsas, 10, 85, noUnderscores);
    drawLineWithText("Cantidad de bochones", formData.cantidadBochones, 75, 85, noUnderscores);
    drawLineWithText("Formación Geológica", especimen.formacion, 140, 85, noUnderscores);

    // Row 4 (Stacked)
    const filo = Array.isArray(especimen.posicionfilo) ? especimen.posicionfilo.join(", ") : especimen.posicionfilo;
    drawLineWithText("Asignación filogenética aproximada", filo, 10, 95);

    // Row 5 (Stacked)
    const partes = Array.isArray(especimen.partesesqueletales) ? especimen.partesesqueletales.join(", ") : especimen.partesesqueletales;
    drawLineWithText("Partes esqueletales", partes, 10, 105);

    // Row 6
    drawLineWithText("Preparador asignado", formData.preparadorAsignado, 10, 115);
    drawLineWithText("Fecha de finalización", formatDate(formData.fechaFinalizacion), 110, 115);
    doc.line(70, 125, 130, 125);
    // Row 7 (Firma below Preparador)
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("Firma investigador responsable:", 10, 125);
    doc.line(70, 125, 130, 125);

    // Observations
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text("Observaciones:", 10, 140);
    doc.setLineWidth(0.2);

    const obsText = formData.observaciones || "";
    const splitObs = doc.splitTextToSize(obsText, pageWidth - 20);

    let yPos = 150;
    for (let i = 0; i < 6; i++) {
        if (splitObs[i]) {
            doc.setFont("helvetica", "normal");
            doc.text(splitObs[i], 10, yPos - 2);
        }
        yPos += 10;
    }

    doc.save(`Hoja_de_Ruta_${nroStr.replace(' ', '_')}.pdf`);
};
